import constants from './constants';

const {
  TOURNAMENT_MEMBER_STATUS,
  TOURNAMENT_MEMBER_ACTIONS,
  TOURNAMENT_MEMBER_PRIZE_PLACE,
} = constants;

const TOURNAMENT_MEMBER_STATUS_DATA = {
  [TOURNAMENT_MEMBER_STATUS.waited]: {
    id: TOURNAMENT_MEMBER_STATUS.waited,
    name: 'Ждёт решения',
    color: 'ui-warning',
  },
  [TOURNAMENT_MEMBER_STATUS.transfered]: {
    id: TOURNAMENT_MEMBER_STATUS.transfered,
    name: 'Переведён в другой раунд',
    color: 'ui-success',
  },
  [TOURNAMENT_MEMBER_STATUS.ended]: {
    id: TOURNAMENT_MEMBER_STATUS.ended,
    name: 'Завершил участие',
    color: 'ui-neutral',
  },
  [TOURNAMENT_MEMBER_STATUS.levelTransfered]: {
    id: TOURNAMENT_MEMBER_STATUS.levelTransfered,
    name: 'Передан на уровень выше',
    color: 'ui-primary',
  },
};

const TOURNAMENT_MEMBER_ACTIONS_DATA = {
  [TOURNAMENT_MEMBER_ACTIONS.transfer]: {
    id: TOURNAMENT_MEMBER_ACTIONS.transfer,
    name: 'Перевести в другой раунд',
    color: 'ui-primary',
    icon: '$ui-arrow-up-right',
  },
  [TOURNAMENT_MEMBER_ACTIONS.finish]: {
    id: TOURNAMENT_MEMBER_ACTIONS.finish,
    name: 'Завершить участие',
    color: 'ui-error',
    icon: '$ui-stop-circle',
  },
  [TOURNAMENT_MEMBER_ACTIONS.remove]: {
    id: TOURNAMENT_MEMBER_ACTIONS.remove,
    name: 'Удалить из группы',
    color: 'ui-error',
    icon: '$ui-delete',
  },
  [TOURNAMENT_MEMBER_ACTIONS.resume]: {
    id: TOURNAMENT_MEMBER_ACTIONS.resume,
    name: 'Возобновить участие',
    color: 'ui-primary',
    icon: '$ui-play-circle',
  },
  [TOURNAMENT_MEMBER_ACTIONS.levelTransfer]: {
    id: TOURNAMENT_MEMBER_ACTIONS.levelTransfer,
    name: 'Передать на следующий уровень',
    color: 'ui-primary',
    icon: '$ui-arrow-up-right',
  },
};

const TOURNAMENT_MEMBER_PRIZE_PLACE_DATA = {
  [TOURNAMENT_MEMBER_PRIZE_PLACE.member]: {
    id: TOURNAMENT_MEMBER_PRIZE_PLACE.member,
    name: 'Участник',
    order: 1,
    certificateName: 'грамоты участника',
    canShow: () => true,
    cantShowReason: () => '',
  },
  [TOURNAMENT_MEMBER_PRIZE_PLACE.winner]: {
    id: TOURNAMENT_MEMBER_PRIZE_PLACE.winner,
    name: 'Победитель',
    order: 2,
    certificateName: 'диплома победителя',
    canShow: ({ award_settings }) => !!award_settings?.prize_places_count,
    cantShowReason: ({ award_settings }) => {
      if (!award_settings) {
        return 'Вашей моделью награждения не предусмотрено награждение победителей';
      }

      return 'Возможность настроить грамоту для призеров появится после включения опции "Победители" в модель награждения мероприятия';
    },
  },
  [TOURNAMENT_MEMBER_PRIZE_PLACE.awarded]: {
    id: TOURNAMENT_MEMBER_PRIZE_PLACE.awarded,
    name: 'Призёр',
    order: 3,
    certificateName: 'диплома призёра',
    canShow: ({ award_settings }) => (award_settings?.prize_places_count > 1) && !!award_settings?.prize_winners_places,
    cantShowReason: ({ award_settings }) => {
      if (!award_settings) {
        return 'Вашей моделью награждения не предусмотрено награждение призеров';
      }

      return 'Возможность настроить грамоту для призеров появится после включения опции "Призеры" в модель награждения мероприятия';
    },
  },
};

const TOURNAMENT_MEMBER_PRIZE_PLACE_LIST =
  Object.values(TOURNAMENT_MEMBER_PRIZE_PLACE_DATA)
    .sort((a, b) => a.order - b.order);

export default {
  TOURNAMENT_MEMBER_STATUS_DATA,
  TOURNAMENT_MEMBER_ACTIONS_DATA,
  TOURNAMENT_MEMBER_PRIZE_PLACE_DATA,
  TOURNAMENT_MEMBER_PRIZE_PLACE_LIST,
};
